module.exports = __webpack_public_path__ + "static/media/android-chrome-256x256.3df6e48b.png";